const MuiButtonBase = {
	defaultProps: {
		// The props to change the default for.
		disableRipple: true, // No more ripple, on the whole application 💣!
	},
};

export default MuiButtonBase;
